import { getBrandConfig } from '../brand'

const brand = getBrandConfig()

export const ServiceIds = brand.serviceIds
export const SPORT_IDS = brand.sportIds

export const DEFAULT_USER_STATS = Object.freeze({
  streak: 0,
  airtimeWon: 0,
  top50Fantasy: 0,
  top50Predictor: 0
})

export const VIP_STATUSES = Object.freeze(['Interested', 'Active', 'Pending', 'Suspended', 'Grace'])

export function getSubscriptionFromGetUser(response) {
  const status = String(response?.status || '').trim()
  const hasPremiumServiceId = response?.serviceId === ServiceIds.premium
  const isSubscribed = hasPremiumServiceId && VIP_STATUSES.some((vip) => vip.toLowerCase() === status.toLowerCase())
  const serviceId = hasPremiumServiceId ? ServiceIds.premium : ServiceIds.free
  return { isSubscribed, serviceId, status }
}

export function transformUserApiResponse(apiResponse, fallbackStats = null) {
  if (!apiResponse?.success) return null

  const { isSubscribed, serviceId, status } = getSubscriptionFromGetUser(apiResponse)

  const subscriptionCategories = apiResponse.subscriptionCategories || []
  const activeSubscriptions = subscriptionCategories
    .filter(cat => cat.status === 1)
    .map(cat => `${cat.category}: true`)

  return {
    ...apiResponse,
    isSubscribed,
    status,
    serviceId,
    username: apiResponse.username || 'Guest',
    Subcriptions: activeSubscriptions.length > 0 ? activeSubscriptions : ['FreeUser: true'],
    subscriptionCategories,
    stats: apiResponse.stats || fallbackStats || DEFAULT_USER_STATS
  }
}

export default {
  ServiceIds,
  SPORT_IDS,
  DEFAULT_USER_STATS,
  getSubscriptionFromGetUser,
  transformUserApiResponse
}
